import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import BinanceSpread from './component/BinanceSpread';
import Login from './component/Login';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <Router>
        <div className="App" style={{ padding: '2rem' }}>
          <Routes>
            <Route path="/" element={<BinanceSpread />} />
            <Route path="/login" element={<Login />} />
          </Routes>
        </div>
      </Router>
    </>
  );
}

export default App;
